import { Directive, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { ViewModel } from '@farris/devkit';
import { DatagridComponent } from '@farris/ui-datagrid';


@Directive({
  selector: "[farris-remote-summary-command]"
})
export class FarrisDataGridRemoteSummaryDirective {
  /**
   * æå¡å¨ç«¯åè®¡å½ä»¤åç§°
   */
  @Input('farris-remote-summary-command') remoteSummaryCommand: string;

  constructor(public viewModel: ViewModel, public grid: DatagridComponent) {
    const appContext = this.viewModel.frameContext.getFormAppContext();
    if (appContext && appContext.hasOwnProperty('messagePipe')) {
      appContext.messagePipe.subscribe((message: any) => {
        const messageType = message && message.type || null;
        // æ¥è¯¢äºä»¶
        if (messageType === 'query') {
          if (this.remoteSummaryCommand && this.grid.footerDataFrom === 'server') {
            const paths = this.remoteSummaryCommand.split('.');
            let func = null;
            paths.forEach(path => {
              func = func && func[path] || this[path];
            });
            if (typeof func === 'function') {
              func().subscribe(result => {
                this.grid.footerData = result;
              });
            }
          }
        }
      });
    }
  }
  /**
   * æ§è¡å½ä»¤
   * @param commandName å½ä»¤åç§°
   * @param frameId frameId
   */
  private execute(commandName: string, frameId?: string): Observable<any> {
    if (!commandName || commandName === '' || commandName === 'undefined') {
      return;
    }
    let viewModel = this.viewModel;
    if (frameId) {
      const targetContext = viewModel.frameContext.appContext.frameContextManager.getFrameContextById(frameId);
      viewModel = targetContext.viewModel;
    }
    return viewModel[commandName]();
  }

}
